exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.description[data-v-670ff235] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 10px 15px 25px 15px;\n  padding: 15px;\n  border: 1px solid #eeeeee;\n  background-color: #fff;\n}\n", ""]);

// exports
